import { Role } from "../../../helpers/role";

export const PDSMenu = [
  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "",
    code: "home",
    role: [Role.PDS],
  },
  {
    title: "Search",
    icon: "mdi-account-search",
    role: [Role.PDS],
    to: "pds-search",
    code: "distributor",
    
  },
  {
    title: "Distributor",
    icon: "mdi-domain",
    role: [Role.PDS],
    to: "pds-distributor",
    code: "distributor",
    
  },

  {
    title: "Upload PDS",
    icon: "mdi-upload",
    to: "pds-uploadPDS",
    code: "uploadPDS",
    role: [Role.PDS],
  },

  {
    title: "SMS",
    icon: "mdi-cellphone-message",
    to: "sms",
    code: "uploadPDS",
    role: [Role.PDS],
  },
 
];
